import { CircularProgress, Grid } from "@mui/material"


interface LoadingComponentInterface {
    loadingText?: string
}

const LoadingComponent = (props: LoadingComponentInterface) => {

    return (
    <Grid
        container
        // alignContent={"center"}
        direction="column"
        justifyContent={"center"}
        alignItems={"center"}
        style={{
          backgroundColor: "black",
          opacity: "0.7",
          position: "fixed",
          width: "100%",
          height: "100%"
        }}
    >
        <Grid position="relative">
          <CircularProgress
            variant="determinate"
            sx={{
              color: (theme) =>
                theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
            }}
            size={40}
            thickness={4}
            value={100}
          />
          <CircularProgress
            variant="indeterminate"
            disableShrink
            sx={{
              animationDuration: '550ms',
              position: 'absolute',
              left: 0,
            }}
            size={40}
            thickness={4}
          />
        </Grid>
        <Grid position="relative">
          <label
            style={{

              color: "white",
              textAlign: "center",
              fontFamily: "Roboto",
              fontSize: "1rem",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "120%"
            }}

          >
            {props.loadingText ? props.loadingText : "Cargando..."}
          </label>
        </Grid>
    </Grid>
    )
}

export default LoadingComponent;